import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Card, Modal } from "react-bootstrap";
import { axiosOpen } from "../../api/axios";
import { useNavigate } from "react-router-dom";
import { deleteOptiizedData } from "../../Utility/utility"
const OpenaiResult = ({ openaiProductData, handleCompletion, setShow }) => {
  const navigate = useNavigate();
  const [productDetails, setProductDetails] = useState(null);
  const [deletePromptModal, setDeletePromptModal] = useState(false);
  const promptID = openaiProductData.promptid || null;

  const handleDiscardModal = () => setDeletePromptModal(false);

  useEffect(() => {
    if (Object.keys(openaiProductData).length > 0) {
      const data = {};
      data.title =
        openaiProductData.title.length > 0
          ? openaiProductData.title.trim()
          : "NA";
      data.description =
        openaiProductData.description.length > 0
          ? openaiProductData.description.trim()
          : "NA";
      data.features =
        openaiProductData.features.length > 0
          ? openaiProductData.features
              .replace("\n\n-", "")
              .replace("\n\n", "")
              .replace(/\n\n/g, "<br/>")
              .replace(/\n•/g, "<br/>")
              .replace("1. ", "")
              .replace(/\n[0-9]./g, "<br/>")
              .replace(/\n-/g, "<br/>")
              .split("<br/>")
          : "NA";
      data.features = data.features.map((list, index) => (
        <li key={index}>{list}</li>
      ));
      setProductDetails(data);
    }
  }, []);

  const handleDiscard = async () => {
    const response = await deleteOptiizedData(promptID);
    setDeletePromptModal(false);
    setShow({
      promptSaved: true,
      advanceSearchForm: false,
      openaiResult: false,
    });
  };

  return (
    <Card style={{ width: "80%", margin: "0 auto" }}>
      <Card.Header className="form-header">Data Optimized</Card.Header>
      <Card.Body>
        <Container>
          <Row>
            <Col>
              <label>
                <b>Product Title:</b>
              </label>
              <p>{productDetails?.title}</p>
            </Col>
          </Row>
          <Row>
            <Col>
              <label>
                <b>Product Description:</b>
              </label>
              <p className="line-break">{productDetails?.description.trim()}</p>
            </Col>
          </Row>
          <Row>
            <Col>
              <label>
                <b>Product Features:</b>
              </label>
              <ul>{productDetails?.features}</ul>
            </Col>
          </Row>
          <Row>
            <Col className="text-center d-flex gap-2 justify-content-center align-items-center">
              <Button variant="primary" onClick={handleCompletion}>
                Done
              </Button>
              <Button
                variant="secondary"
                onClick={() => setDeletePromptModal(true)}
              >
                Cancel
              </Button>
            </Col>
          </Row>
        </Container>
      </Card.Body>
      <Modal show={deletePromptModal} onHide={handleDiscardModal}>
        <Modal.Header closeButton>
          <Modal.Title className="font-size-primary">
            Are you sure you want to discard the prompt ?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="font-size-secondary">
          The prompt will be deleted immediately. You can't undo this action
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="font-size-secondary"
            variant="secondary"
            onClick={handleDiscardModal}
          >
            Cancel
          </Button>
          <Button
            className="font-size-secondary"
            variant="primary"
            onClick={handleDiscard}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </Card>
  );
};

export default OpenaiResult;
